export default __webpack_public_path__ + "static/media/default-user.c3f94521.png";